/**
 * User: hella
 * Date: 6/22/14
 * Time: 3:21 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var $ = require('dibs-jquery-shim');
var MEC = require('../modalEmailConstants');
var SV = require('server-vars');
var findNamespaceValue = require('find-namespace-value');

module.exports = {
    /**
     * custom dibsvalidation function for emaillist
     * @returns {String} if false {Boolean} if true
     */
    validateEmailList : function validateEmailList(val) {
        var i = 0;
        var addresses = val.split(',');
        var valid = addresses.length > 0;
        while (valid && (i < addresses.length)) {
            valid = MEC.EMAIL.FORMAT.test($.trim(addresses[i]));
            i++;
        }
        if (valid) {
            return true;
        }
        return findNamespaceValue('modalData.validationCopy.emailListMessage', SV);
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/mixins/mixins.js
// module id = 1187
// module chunks = 4 7 12